import { MenuItem } from 'vue-graphql-models';

export default [

  new MenuItem({
    id: 'createNewOrganization',
    title: 'Create New Organization',
    subtitle: 'Add New Organization',
    route: { name: 'createNewOrganization' },
    customIcon: true,
    icon: 'dhc-new',
  }),
  new MenuItem({
    id: 'organizationHelp',
    title: 'Help',
    subtitle: 'How to\'s and Contact Info',
    customIcon: true,
    icon: 'dhc-help',
  }),
  new MenuItem({
    id: 'editOrgAssets',
    title: 'Edit Org Assets',
    subtitle: 'Add/Remove Users to Assets',
    customIcon: true,
    icon: 'dhc-pencil-s',
  }),
  new MenuItem({
    id: 'organizationEdit',
    title: 'Edit Organization',
    subtitle: 'Edit Organization Details',
    route: { name: 'organizationEdit' },
    customIcon: true,
    icon: 'dhc-pencil-s',
  }),
  new MenuItem({
    id: 'organizationDelete',
    title: 'Delete Organization',
    subtitle: 'Remove Organization Record',
    route: { name: 'contactForm' },
    customIcon: true,
    icon: 'dhc-trash',
  }),
  new MenuItem({
    id: 'organizationClone',
    title: 'Clone Organization',
    subtitle: 'Clone Organization Details',
    route: { name: 'organizations' },
    customIcon: true,
    icon: 'dhc-new',
  }),
  new MenuItem({
    id: 'organizationsHelp',
    title: 'Help',
    subtitle: 'How to\'s and Contact Info',
    customIcon: true,
    icon: 'dhc-help',
  }),
  new MenuItem({
    id: 'logoCreate',
    title: 'Upload Logo',
    subtitle: 'Upload a new Logo for Organization',
    icon: 'cloud_upload',
  }),
];
